module.exports = __webpack_public_path__ + "img/diamond.6d7ec8df.gif";